<template>
  <div class="page-container">
    <section>
      <Accounts @emitResult="next" />
    </section>
  </div>
</template>

<script>
import { redirectSignupManage } from '@/util/signupManage'
export default {
  components: { Accounts: () => import('@/components/account/Accounts.vue') },
  async created() {
    _meta({
      titles: ['매출계정연동'],
    })
  },
  methods: {
    async next() {
      if (await redirectSignupManage()) {
        return
      }
      // await this.$router.push({ name: 'factoring/confirm' })
      await this.$router.replace('/')
    },
  },
}
</script>
